import React, { useEffect, useState } from "react";
import { Tag } from "primereact/tag";
import styles from "../my-calendar.module.scss";
import PropTypes from "prop-types";
import EventDetail from "./EventDetail";
import { Tooltip } from "primereact/tooltip";
import { Badge } from "primereact/badge";
import { InputText } from "primereact/inputtext";
import useDateTime from "~/hooks/useDateTime";
import { useDispatch, useSelector } from "react-redux";
import CustomeButton from "~/components/Button";
import { toZonedTime } from "date-fns-tz";
import { getLspDetails } from "~/Pages/Lsp/actions/lspSlice";
import { Skeleton } from "primereact/skeleton";
import Timelines from "~/components/Timeline";
import StatusBadge from "~/Pages/Process/components/StatusBadge";
import { format, parse } from "date-fns";

const EventDetailCalenderPayrollPlus = ({
  eventDetail,
  handleCloseEventDetailCalander,
  backBtn,
  handleViewMoreEvent,
  closeEventBtn = true,
}) => {
  const { formatDateTime } = useDateTime();
  const dispatch = useDispatch();
  const [payslipUrl, setPayslipUrl] = useState(null);
  const [deadlineTime, setDeadlineTime] = useState(null);
  const { timezone, id, lsp_id, role } = useSelector((state) => state.login);
  const { lspdetails } = useSelector((state) => state.lsponboarding);

  const viewProcessHandler = () => {
    window.open(
      window.location.origin +
        "/process/" +
        eventDetail?.process +
        "/milestones",
    );
  };

  const viewPayslip = () => {
    window.open(payslipUrl);
  };

  const getDateInEntityTimezone = (date) => {
    const utcDate = new Date(date);
    const timeZone = eventDetail?.entityData?.timezone;
    const zonedDate = toZonedTime(utcDate, timeZone);
    setDeadlineTime(zonedDate);
  };

  useEffect(() => {
    getDateInEntityTimezone(eventDetail?.due_date_utc);
  }, [eventDetail?.entityData]);

  useEffect(() => {
    if (lsp_id) {
      dispatch(getLspDetails(lsp_id));
    }
  }, [lsp_id, dispatch]);

  const resolvePayslipUrl = () => {
    const CUSTOMER_ROLES = ["CUSTOMER", "CUSTOMER_MANAGER"];
    const GXM_ROLES = ["GXM_USER", "GXM_MANAGER", "GXM_ADMIN"];
    if ([...CUSTOMER_ROLES, ...GXM_ROLES].includes(role)) {
      setPayslipUrl("https://hsp.payslip.com/dashboard/");
      return;
    }
    const service = lspdetails?.active_services?.find(
      (s) => s?.name === "Payroll +",
    );
    if (!service) return;
    const match = lspdetails?.service_url_override?.find(
      (obj) => obj[service.id],
    );
    if (match?.[service.id]?.[0]) {
      setPayslipUrl(match[service.id][0]);
    }
  };

  useEffect(() => {
    resolvePayslipUrl();
  }, [lspdetails, role]);

  const formatDateRange = (dateRangeStr) => {
    if (!dateRangeStr) return "";

    const [startStr, endStr] = dateRangeStr.split("-");

    const startDate = parse(startStr, "dd/MM/yyyy", new Date());
    const endDate = parse(endStr, "dd/MM/yyyy", new Date());

    const formattedStart = format(startDate, "MMMM do, yyyy");
    const formattedEnd = format(endDate, "MMMM do, yyyy");

    return `${formattedStart} - ${formattedEnd}`;
  };

  return (
    <div className={styles["event-detail-container"]}>
      <div className={styles["event-header-container"]}>
        <div className="flex align-items-center">
          {backBtn && (
            <span className={styles["back"]}>
              <i className="pi pi-arrow-left" onClick={handleViewMoreEvent}></i>
            </span>
          )}
          <div className={styles["event-header"]}>
            <h2 className={styles["event-header-title"]}>
              {eventDetail?.title}
            </h2>
          </div>
        </div>
        {closeEventBtn && (
          <span className={styles["close__calander"]}>
            <i
              className="pi pi-times"
              onClick={handleCloseEventDetailCalander}
            ></i>
          </span>
        )}
      </div>
      <div className={styles["sidenav-process"]}>
        <div className="w-full">
          <div className="sidebar-milestones-container">
            <div className={styles["details"]}>
              <p className={styles["sidebar-details-label"]}>Details</p>
              <div className={styles["field"]}>
                <label className="input-label">Status</label>
                <div className="p-inputtext w-full request__calander__input flex align-items-center">
                  <Badge
                    style={{
                      backgroundColor: eventDetail?.status?.primary_color,
                    }}
                    className="opacity-60"
                  />
                  <span className="opacity-60">
                    {eventDetail?.status?.name}
                  </span>
                </div>

                <span
                  className={styles["sidenav-input-icon-date"]}
                  data-testid="sidenav-input-icon"
                >
                  <i className="pi pi-lock"></i>
                </span>
              </div>
              <div className={styles["field"]}>
                <label className="input-label">Due Date</label>
                <InputText
                  value={formatDateTime({
                    date: deadlineTime,
                    dateformat: "MMMM do, yyyy",
                  })}
                  readOnly
                  className="w-full request__calander__input"
                  placeholder="Select date"
                  disabled
                />
                <span
                  className={styles["sidenav-input-icon-date"]}
                  data-testid="sidenav-input-icon"
                >
                  <i className="pi pi-lock"></i>
                </span>
              </div>
              <div className={styles["field"]}>
                <label className="input-label">Service Line</label>
                <InputText
                  value={"Payroll Plus"}
                  placeholder="Select Service Line"
                  name="email"
                  className="appearance-none outline-none w-full "
                  disabled
                />
                <span
                  className={styles["sidenav-input-icon-lock"]}
                  data-testid="sidenav-input-icon-lock"
                >
                  <i className="pi pi-lock"></i>
                </span>
              </div>
              <div className={styles["field"]}>
                <label className="input-label">Process Name</label>
                <InputText
                  value={eventDetail?.title}
                  placeholder="Select Process Name"
                  name="process"
                  className={`appearance-none outline-none w-full ${styles["truncate-value"]}`}
                  disabled
                />
                <span
                  className={styles["sidenav-input-icon-lock"]}
                  data-testid="sidenav-input-icon-lock"
                >
                  <i className="pi pi-lock"></i>
                </span>
              </div>

              <div className={styles["field"]}>
                <label className="input-label">Period</label>
                <InputText
                  value={formatDateRange(eventDetail?.processData?.payrun)}
                  placeholder="Select Process Name"
                  name="process"
                  className={`appearance-none outline-none w-full ${styles["truncate-value"]}`}
                  disabled
                />
                <span
                  className={styles["sidenav-input-icon-lock"]}
                  data-testid="sidenav-input-icon-lock"
                >
                  <i className="pi pi-lock"></i>
                </span>
              </div>
              <div className={styles["action-buttons"]}>
                <CustomeButton
                  label="Open Process"
                  variant="contained"
                  onClick={viewProcessHandler}
                />
              </div>
              <div className={styles["action-buttons"]}>
                <CustomeButton
                  label="Open Payslip"
                  onClick={viewPayslip}
                  icon="pi pi-external-link"
                  iconPos="right"
                  disabled={!payslipUrl}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
EventDetailCalenderPayrollPlus.propTypes = {
  eventDetail: PropTypes.object,
  handleCloseEventDetailCalander: PropTypes.func,
  backBtn: PropTypes.bool,
  handleViewMoreEvent: PropTypes.func,
  closeEventBtn: PropTypes.bool,
};

export default EventDetailCalenderPayrollPlus;
